<template>
  <div style="height: 100%" :class="theme == 1 ? 'white' : 'black'">
    <!-- <van-nav-bar
            title="支付"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
    />-->
    <div class="main-block" v-if="product.priceList">
      <div class="pay-title">
        <div class="title-left">
          <van-image :src="apiHost + product.thumbnailUrl" style="
              width: 1.85rem;
              height: 1.08rem;
              border-radius: 0.08rem;
              overflow: hidden;
            " fit="cover" />
        </div>
        <div class="title-right">
          <span class="pro-name">
            {{ product.name }}
            <span v-if="$route.query.isRenewal" style="
                display: inline-block;
                text-align: center;
                width: 36px;
                height: 16px;
                background: #f44336;
                border-radius: 2px;
                color: #fff;
                font-size: 11px;
              ">续费</span>
          </span>
          <span class="pro-summary">{{ product.summary }}</span>
        </div>
      </div>

      <div class="title fs30">开通时长</div>

      <div class="pricelist" :class="theme == 1 ? 'bdeeeff4' : 'bd000'">
        <div class="priceitem" v-for="(item, index) in product.priceList" :key="item.type"
          @click="onCellClick(index, item)" v-bind:class="{ active: item.type == dateType }">
          <span class="price-name">{{ item.name }}</span>
          <span class="price-discount">
            <label style="font-size: 15px; font-weight: 400">¥</label>
            {{ item.discountPrice }}
          </span>
          <span class="price-normal">¥{{ item.price }}</span>
          <div v-if="item.label != ''" class="recommend">
            <span style="display: inline-block">{{ item.label }}</span>
          </div>
        </div>
      </div>
      <van-cell title="优惠" :border="false" :title-style="{ fontSize: '15px' }"
        :value-class="discountText == '暂不用券' ? 'valueClass1' : 'valueClass'" @click="(listShow = true), menuKey++"
        v-if="discounts" :style="theme == 1
          ? 'border-bottom: 8px solid #eeeff4'
          : 'border-bottom: 8px solid #000'
          " is-link :value="discountText" />
      <!-- </van-panel> -->
      <div v-if="ApplePay != 1">
        <div class="title fs30" style="border: 0">支付方式</div>
        <div class="pay" v-if="ApplePay == 0" :class="theme == 1 ? 'bdeeeff4' : 'bd000'">
          <div class="pay-item">
            <div class="wechatpay" v-bind:class="{ wechatactive: payType == 1 }" @click="payType = 1">
              <img class="icon1" v-if="theme == 2" src="../assets/wechat_pay2.png" />
              <img class="icon1" v-else :src="payType == 2 ? wx_w : wx_b" />
              <div class="remark">推荐微信5.0以上的用户使用</div>
            </div>
          </div>
          <div class="pay-item">
            <div class="alipay" v-bind:class="{ alipayactive: payType == 2 }" @click="payType = 2">
              <img class="icon" v-if="theme == 2" src="../assets/alipay2.png" />
              <img class="icon" v-else :src="payType == 2 ? zfb_w : zfb_b" />
              <div class="remark">推荐有支付宝账号用户使用</div>
            </div>
          </div>
        </div>
        <div class="pay1" v-else :class="theme == 1 ? 'bdeeeff4' : 'bd000'">
          <div class="pay1_item" v-if="ApplePay == 2" @click="payType = 1">
            <img src="../assets/wx.png" style="width: 0.66rem; height: 0.57rem; padding-right: 0.36rem" alt="" />
            <p>微信支付</p>
            <img v-if="payType == 1" src="../assets/xza2.png" style="width: 0.44rem; height: 0.44rem" alt />
            <img v-else src="../assets/xza1.png" style="width: 0.44rem; height: 0.44rem" alt />
          </div>
          <div class="pay1_item" v-if="ApplePay == 2" @click="payType = 2">
            <img style="width: 0.58rem; height: 0.58rem; padding-right: 0.4rem" src="../assets/zfb.png" alt="" />
            <p>支付宝</p>
            <img v-if="payType == 2" src="../assets/xza2.png" style="width: 0.44rem; height: 0.44rem" alt />
            <img v-else src="../assets/xza1.png" style="width: 0.44rem; height: 0.44rem" alt />
          </div>
          <div class="pay1_item" @click="payType = 8">
            <img v-if="theme == 1" style="width: 0.74rem; height: 0.48rem; padding-right: 0.3rem" src="../assets/app.png"
              alt="" />
            <img v-else style="width: 0.74rem; height: 0.48rem; padding-right: 0.3rem" src="../assets/app1.png" alt="" />
            <p>Apple Pay</p>
            <img v-if="payType == 8" src="../assets/xza2.png" style="width: 0.44rem; height: 0.44rem" alt />
            <img v-else src="../assets/xza1.png" style="width: 0.44rem; height: 0.44rem" alt />
          </div>
        </div>
      </div>
      <div class="tishi" style="height: 1.28rem; display: flex">
        <div @click="isOkClick()">
          <img v-if="showImg == true" src="../assets/xza2.png" style="
              width: 0.36rem;
              height: 0.36rem;
              padding: 0.26rem 0.2rem 0 0.32rem;
            " alt />
          <img v-else src="../assets/xza1.png" style="
              width: 0.36rem;
              height: 0.36rem;
              padding: 0.26rem 0.2rem 0 0.32rem;
            " alt />
        </div>
        <div class="fxts">
          <p style="width: 2.8rem">我已阅读并接受</p>
          <p style="color: #3395ff">
            <span @click="toInfo1">《风险提示书》</span>
            <span @click="toInfo2">《投顾服务协议》</span>
            <span @click="toInfo3">《适当性评估》</span>
          </p>
        </div>
      </div>
    </div>

    <div class="pay-boot" v-show="showBtn">
      <div class="Points-pay" @click="goMorePay" v-if="(this.price - this.discountMoney).toFixed(2) > 1 && AppTITLE != '神光'
        ">
        <span>单笔额度不足？尝试分笔支付</span><van-icon name="arrow" style="padding-top: 0.05rem" size="16px" color="#FF9500" />
      </div>
      <div style="padding: 8px 16px">
        <van-button type="info" color="#F44336" class="fs34" v-if="showImg == true" block round @click="doPayRequest">{{
          buttonText }}</van-button>
        <van-button type="info" round class="fs34" color="rgba(244, 67, 54, 0.5)" v-else block>{{ buttonText
        }}</van-button>
      </div>
    </div>
    <van-popup v-model="listShow" round position="bottom" :style="{ height: '9.1rem' }">
      <Coupon @close="close" :price="price" :UseList="UseList" :theme="theme" :key="menuKey"></Coupon>
    </van-popup>
    <van-dialog v-model="showPayState" :show-cancel-button="false" :show-confirm-button="false" class="pay-dialog">
      <div class="pay-state-dialog">
        <div style="height: 1px"></div>
        <div class="tip-content">
          {{ payTipContent
          }}<span v-if="payTipContent == '正在连接Appstore'" class="loading">...</span>
        </div>
        <img v-if="payState == 0" src="../assets/pay-state-1.png" style="margin: 33px 1.96rem" width="66" height="66"
          round fit="cover" />
        <img v-if="payState == 1" src="../assets/pay-state-3.png" style="margin: 33px 1.96rem" width="66" height="66"
          round fit="cover" />
        <img v-if="payState == 2" src="../assets/pay-state-2.png" style="margin: 33px 1.96rem" width="66" height="66"
          round fit="cover" />
        <div class="pay-msg">{{ payMsg }}</div>
        <div v-if="payState == 0" class="pay-btn-complate" @click="showPayStateClick">
          支付完成
        </div>
        <div v-if="payState == 1" class="pay-btn-success" @click="$router.push('/paysuccess')">
          完成
        </div>
        <div v-if="payState == 2" class="pay-btn-fail" @click="showPayStateClick">
          返回支付页
        </div>
        <div v-if="payState == 0" class="pay-btn-cancel" @click="showPayStateClick">
          放弃支付
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  NavBar,
  Image,
  Divider,
  Toast,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Button,
  Panel,
  Icon,
  Tag,
  Dialog,
  Popup,
} from "vant";
import MallServiceApi from "@/api/mall";
import PayServiceApi from "@/api/dk";
import payApi from "@/api/pay";
import { getUrlParams } from "@/utils/utility";
import Coupon from "@/components/Coupon.vue";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
import router from "../router";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");

var picHost = process.env.VUE_APP_PIC_BASE_URL;
var picHost1 = process.env.VUE_APP_HTTP_BASE_URL;
var apiHost = process.env.VUE_APP_API_BASE_URL;
var AppTITLE = process.env.VUE_APP_TITLE;
export default {
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Divider.name]: Divider,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    Coupon,
  },

  data() {
    return {
      dateType: 1,
      payType: 1,
      product: {},
      productId: null,
      type: null,
      buttonText: "立即开通",
      AppTITLE: AppTITLE,
      picHost: picHost,
      menuKey: 1,
      apiHost: apiHost,
      showPayState: false,
      payState: 0,
      payTipContent: "支付中",
      payMsg: "付款完成前请不要关闭此窗口",
      payNo: "",
      price: "",
      timer: null,
      isOk: false,
      name: "",
      showImg: true,
      listShow: false,
      isAuth: 1,
      isRisk: 1,
      showBtn: true,
      productCategoryId: "",
      theme: "1",
      zfb_w: require("../assets/alipay.png"),
      zfb_b: require("../assets/alipay1.png"),
      wx_w: require("../assets/wechat_pay.png"),
      wx_b: require("../assets/wechat_pay1.png"),
      wx_b2: require("../assets/wechat_pay2.png"),
      zfb_b2: require("../assets/wechat_pay2.png"),
      UseList: [],
      discountMoney: "",
      discountText: "",
      discounts: false,
      myDiscountCouponId: "",
      pricetype: 0,
      title: "",
      num: 1,
      ApplePay: 0,
      // moneyType: "",
      // days: "",
      // groupType: "",
    };
  },
  mounted() {
    var that = this;
    if (userAgent.android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
  },

  created() {
    if (getUrlParams("id")) {
      this.productId = getUrlParams("id");
    } else {
      this.productId = sessionStorage.getItem("productId");
    }
    if (getUrlParams("type")) {
      this.type = getUrlParams("type");
    } else {
      this.type = sessionStorage.getItem("producttype");
    }
    if (
      sessionStorage.getItem("ApplePay") &&
      sessionStorage.getItem("ApplePay") != "null"
    ) {
      console.log(sessionStorage.getItem("ApplePay"));

      this.ApplePay = sessionStorage.getItem("ApplePay");
      if (this.ApplePay == 1) {
        this.payType = 8;
        this.payTipContent = "正在连接Appstore";
      }
    }

    this.getProductInfo();
    var token = sessionStorage.getItem("Access-Token");
    if (token != "null" && token != "" && token != null) {
      this.getRiskInfo();
    }
    if (sessionStorage.getItem("a") == "a") {
      this.isOk = true;
    }
    if (sessionStorage.getItem("paytype")) {
      this.payType = sessionStorage.getItem("paytype");
    }
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }

    if (sessionStorage.getItem("payNo")) {
      this.showPayState = true;
      this.payNo = sessionStorage.getItem("payNo");
      this.timer = setInterval(() => {
        this.doSearchPayState();
      }, 2000);
    }
    if (getUrlParams("qtype") && sessionStorage.getItem("url")) {
      var url = sessionStorage.getItem("url");
      this.payType = sessionStorage.getItem("payType");
      var orderNo = sessionStorage.getItem("orderNo");
      var payNo = sessionStorage.getItem("payNo");
      var dateType = sessionStorage.getItem("dateType");
      console.log(url);

      if (getUrlParams("payType") == 8) {
        setTimeout(() => {
          window.WebViewJavascriptBridge.callHandler(
            "ApplePayAction",
            {
              param: {
                orderNo: orderNo,
                payNo: payNo,
                payType: 8,
                dateType: dateType,
                productId: this.productId,
                producttype: this.type,
              },
            },
            function (responseData) { }
          );
        }, 2000);
        return false;
      }
      if (userAgent.android) {
        // window.location.href = url;
        if (this.payType == 1) {
          url =
            picHost1 + "/mall/forward?redirect_url=" + encodeURIComponent(url);
        } else {
          url =
            picHost1 +
            "/mall/forward?payType=2&redirect_url=" +
            encodeURIComponent(url);
        }
        console.log(url);
        // this.$router.go(-1);
        this.$bridge.callmethod("webPushNative", {
          action: "h5",
          param: { url: url },
        });
      } else {
        if (this.payType == 1) {
          url =
            picHost1 +
            "/mall/forward?payType=3&redirect_url=" +
            encodeURIComponent(url);
        }
        // this.$router.go(-1);
        setTimeout(() => {
          window.WebViewJavascriptBridge.callHandler(
            "webPushNative",
            { action: "h5Out", param: { url: url } },
            function (responseData) { }
          );
        }, 2000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {
    clearInterval(this.timer);

    // sessionStorage.removeItem("payNo");
  },
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  methods: {
    getRiskInfo() {
      MallServiceApi.getRiskInfo({}).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.title = res.data.title;
        }
      });
    },

    showPayStateClick() {
      this.showPayState = false;
      sessionStorage.removeItem("payNo");
      this.$router.go(-4);
    },
    getUserDiscountCouponUseList(price) {
      let params = {
        productCategoryId: this.type,
        productId: this.productId,
        payMoney: price,
        pageSize: 1000,
      };
      MallServiceApi.getUserDiscountCouponUseList(params).then((res) => {
        if (res.code == 200) {
          var list = [];
          res.data.records.forEach((p) => {
            if (p.discountMsg.indexOf("￥") != -1) {
              p.Msg = p.discountMsg.replace(/￥/g, "");
              p.MsgType = 1;
            } else {
              p.Msg = p.discountMsg.replace(/折/g, "");
              p.MsgType = 2;
            }
            list.push(p);
          });

          this.UseList = list;
          // console.log(res.data.records)
          if (res.data.records[0].used == 1) {
            res.data.records[0].actived = true;
            this.discountMoney = res.data.records[0].discountMoney;
            this.discountText = "-" + this.discountMoney.toFixed(2);
            this.myDiscountCouponId = res.data.records[0].id;
            this.discounts = true;
            var Textprice;
            if ((price - this.discountMoney).toFixed(2) > 0) {
              Textprice = (price - this.discountMoney).toFixed(2);
            } else {
              Textprice = 0.0;
            }
            this.buttonText = "支付¥" + Textprice + " 立即开通";
          } else {
            this.discountMoney = 0;
            this.discounts = false;
          }
          console.log(this.UseList);
        }
      });
    },
    goMorePay() {
      sessionStorage.setItem("paytype", this.payType);
      if (!this.discountMoney) {
        this.discountMoney = 0;
      }
      var query = {
        type: this.type,
        id: this.productId,
        discountMoney: this.discountMoney.toFixed(2),
        theme: this.theme,
        pricetype: this.pricetype,
      };
      if (this.myDiscountCouponId) {
        query.myDiscountCouponId = this.myDiscountCouponId;
      }
      this.$router.push({ path: "/morePay", query: query });
    },
    isOkClick() {
      if (this.showImg == true) {
        this.showImg = false;
      } else {
        this.showImg = true;
      }
    },
    toInfo1() {
      this.$router.push("./fxtss?theme=" + this.theme + "&next=0");
    },
    toInfo2() {
      var query = {
        type: this.type,
        id: this.productId,
        price: this.price,
        time: this.name,
        name: this.product.name,
        theme: this.theme,
        next: 0,
      };
      this.$router.push({ path: "./xieyi", query: query });
    },
    toInfo3() {
      this.$router.push("./sdxpg?theme=" + this.theme + "&next=0");
    },
    close(data) {
      console.log(data);
      this.listShow = false;
      if (data == 0) {
        this.discountMoney = 0;
        this.discountText = "暂不用券";
        this.myDiscountCouponId = "";
      } else {
        this.discountMoney = data.discountMoney;
        this.discountText = "-" + this.discountMoney.toFixed(2);
        this.myDiscountCouponId = data.id;
      }
      var price;
      if ((this.price - this.discountMoney).toFixed(2) > 0) {
        price = (this.price - this.discountMoney).toFixed(2);
      } else {
        price = 0.0;
      }
      this.buttonText = "支付¥" + price + " 立即开通";
      // if (data == 1) {
      //   this.page = 1;
      //   this.getCusList();
      // }
    },
    gofxts() {
      var query = {
        type: this.type,
        id: this.productId,
        price: this.price,
        time: this.name,
        name: this.product.name,
        myDiscountCouponId: this.myDiscountCouponId,
        theme: this.theme,
      };
      // console.log(query);
      this.$router.push({ path: "/fxts", query: query });
    },
    getProductInfo() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      MallServiceApi.getProductInfo({
        productCategoryId: this.type,
        id: this.productId,
      }).then((res) => {
        Toast.clear();
        // console.log(res);
        if (res.code == 200) {
          this.product = res.data;
          // this.moneyType = res.data.moneyType;
          // this.days=res.data.days
          this.productCategoryId = res.data.productCategoryId;
          // console.log(this.productCategoryId);
          var index = 0;
          if (sessionStorage.getItem("index")) {
            index = sessionStorage.getItem("index");
            this.pricetype = index;
          }

          this.name = res.data.priceList[index].name;
          this.dateType = res.data.priceList[index].type;
          this.price = res.data.priceList[index].discountPrice;

          if (this.price >= 6000 && sessionStorage.getItem("ApplePay") == 2) {
            this.ApplePay = 0;
          } else if (sessionStorage.getItem("ApplePay") == 2) {
            this.ApplePay = sessionStorage.getItem("ApplePay");
          }
          this.buttonText =
            "支付¥" + res.data.priceList[index].discountPrice + " 立即开通";
          this.getUserDiscountCouponUseList(this.price);
          this.getuserInfo();
        } else if (res.code == 401) {
          setTimeout(() => {
            this.getProductInfo();
          }, 1000);
        }
      });
    },
    onClickLeft() {
      this.$router.back();
    },
    onCellClick(index, item) {
      this.pricetype = index;
      this.dateType = item.type;
      this.price = item.discountPrice;
      console.log(this.price);
      if (this.price >= 6000 && sessionStorage.getItem("ApplePay") == 2) {
        this.ApplePay = 0;
      } else if (sessionStorage.getItem("ApplePay") == 2) {
        this.ApplePay = sessionStorage.getItem("ApplePay");
      }
      this.name = item.name;
      this.buttonText = "支付¥" + item.discountPrice + " 立即开通";
      sessionStorage.setItem("index", index);
      this.getUserDiscountCouponUseList(this.price);
    },
    getuserInfo() {
      var that = this;
      // if(this.num==1){
      //   this.num++
      //   sessionStorage.setItem("Access-Token", this.productId);
      // }
      MallServiceApi.getUserInfo({}).then(function (res) {
        console.log(sessionStorage.getItem("Access-Token"));

        if (res.code == 200) {
          that.avatar = res.data.avatar;
          that.userName = res.data.userName;
          that.levelLabel = res.data.levelLabel;
          that.levelExpire = res.data.levelExpire;
          that.isAuth = res.data.isAuth;
          that.isRisk = res.data.isRisk;
          that.level = res.data.level;
          that.showBtn = true;
          //   that.userId = res.data.userId;
          //   sessionStorage.setItem("userId", that.userId);
          //   that.getcelueList();
        } else if (res.code == 401) {
          setTimeout(() => {
            // console.log("123456");
            this.getuserInfo();
          }, 1000);
        }
      });
    },
    doPayRequest() {
      var token = sessionStorage.getItem("Access-Token");
      sessionStorage.setItem("paytype", this.payType);
      if (token != "null" && token != "" && token != null) {
        MallServiceApi.getUserInfo({}).then((res) => {
          // console.log(res);
          if (res.code == 200) {
            // this.avatar = res.data.avatar;
            // this.userName = res.data.userName;

            this.isAuth = res.data.isAuth;
            this.isRisk = res.data.isRisk;
            this.level = res.data.level;
            this.showBtn = true;
            //   that.userId = res.data.userId;
            //   sessionStorage.setItem("userId", that.userId);
            //   that.getcelueList();
            if (res.data.isAuthorization == 1) {
              console.log(this.title);
              if (this.isAuth != "1") {
                let params = {
                  params: window.location.href,
                  deviceType: 2,
                };
                MallServiceApi.getAccountRegister(params).then((res) => {
                  if (res.code == 200) {
                    window.location.replace(res.data.url);
                  }
                });
              } else if (this.isRisk != "1") {
                var query = {
                  type: this.type,
                  id: this.productId,
                  myDiscountCouponId: this.myDiscountCouponId,
                  theme: this.theme,
                };
                this.$router.push({ path: "/fxcp", query: query });
              } else if (this.title == "谨慎型") {
                var query = {
                  type: this.type,
                  id: this.productId,
                  myDiscountCouponId: this.myDiscountCouponId,
                  theme: this.theme,
                };
                this.$router.push({ path: "/fxcp", query: query });
              } else if (this.title == "保守型") {
                var query = {
                  type: this.type,
                  id: this.productId,
                  myDiscountCouponId: this.myDiscountCouponId,
                  theme: this.theme,
                };
                this.$router.push({ path: "/fxcp", query: query });
              } else {
                var query = {
                  type: this.type,
                  id: this.productId,
                  price: this.price,
                  time: this.name,
                  name: this.product.name,
                  myDiscountCouponId: this.myDiscountCouponId,
                  dateType: this.dateType,
                  ptype: 1,
                  payType: this.payType,
                  productCategoryId: this.productCategoryId,
                  theme: this.theme,
                };
                this.zhifu(query);
              }
            }
          }
        });

        // var params = {
        //   dateType: this.dateType,
        //   courseId: this.productId,
        // };
        // if (this.payType == 1) {
        //   params.payWay = 3;
        // } else {
        //   params.payWay = 2;
        // }

        // params.productCategoryId = this.type;

        // PayServiceApi.productPay(params).then((res) => {
        //   if (res.code != 200) {
        //     Toast.fail(res.message);
        //     return;
        //   }
        //   this.showPayState = true;
        //   var url = res.data.url;
        //   this.payNo = res.data.payNo;
        //   // this.timer = setInterval(this.doSearchPayState(payNo), 2000);
        //   if (this.payType == 1) {
        //     url =
        //       "http://store.youruitech.com/mall/forward?redirect_url=" +
        //       encodeURIComponent(url);
        //   }
        //   // window.location.href = url;
        //   window.WebViewJavascriptBridge.callHandler(
        //     "webPushNative",
        //     { action: "h5Out", param: { url: url } },
        //     function (responseData) {}
        //   );
        // });
      } else {
        var that = this;

        if (userAgent.android) {
          this.$bridge.callmethod("gotoLogin", function (responseData) {
            responseData = JSON.parse(responseData);
            // console.log(responseData);
            that.userId = responseData.userId;
            that.userToken = responseData.userToken;
            sessionStorage.setItem("userId", that.userId);
            sessionStorage.setItem("Access-Token", that.userToken);
            that.getRiskInfo();
            // getHeaderToken(myWebkey, myuserId)
          });
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "gotoLogin",
            {},
            function (responseData) {
              responseData = JSON.parse(responseData);
              // console.log(responseData);
              that.userId = responseData.userId;
              that.userToken = responseData.userToken;
              sessionStorage.setItem("userId", that.userId);
              sessionStorage.setItem("Access-Token", that.userToken);
              that.getRiskInfo();
              // getHeaderToken(myWebkey, myuserId)
            }
          );
        }
      }
    },
    zhifu(query) {
      Toast.loading({
        message: "支付中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      var params = {
        dateType: query.dateType,
        courseId: query.id,
        productCategoryId: query.productCategoryId,
        userAgreementId: this.userAgreementId,
        myDiscountCouponId: query.myDiscountCouponId,
        payType: query.ptype,
      };
      sessionStorage.setItem("dateType", query.dateType);
      if (this.payType == 1) {
        params.payWay = 3;
        // if (userAgent.android && userAgent.YouRui) {
        //   params.payWay = 5;
        // }
      } else if (this.payType == 2) {
        params.payWay = 2;
        params.pageSource = 3;
      } else if (this.payType == 8) {
        params.payWay = 8;
      }
      if (this.realPay > 0) {
        params.prepaidMoney = this.realPay;
      } else {
        params.prepaidMoney = this.price;
      }
      payApi.productPay(params).then((res) => {
        // console.log(res, 617);
        if (res.code != 200) {
          Toast.fail(res.message);
          return;
        }

        MallServiceApi.ageCorrection({ orderNo: res.data.orderNo }).then(reset1 => {
          if (reset1.code == 200) {
            var isContract= reset1.data.isContract
           
            if(isContract==1||isContract==2){
              this.$router.push('/tishi?isContract='+isContract)
              return false
            }
            let params = {
              source: 2,
              contractType: 3,
              params: window.location.href + "&qtype=1&payType=" + this.payType,
              orderNo: res.data.orderNo,
            };
            MallServiceApi.getExtsign(params).then((data) => {
              if (data.code == 200) {
                if (this.ApplePay == 1) {
                  window.location.replace(window.location.href + "&qtype=1&payType=" + this.payType);
                  localStorage.setItem("htUrl", data.data);
                } else {
                  localStorage.setItem("htUrl", data.data);
                  this.$router.push("/sdxpg?type=app&routeType=2");
                }
              }
            });
            var url = res.data.url;
            this.payNo = res.data.payNo;
            sessionStorage.setItem("orderNo", res.data.orderNo);
            sessionStorage.setItem("payNo", this.payNo);
            sessionStorage.setItem("url", url);
            sessionStorage.setItem("payType", this.payType);
          }

        })



      });
    },
    doSearchPayState() {
      if (sessionStorage.getItem("payNo")) {
        this.payNo = sessionStorage.getItem("payNo");
        this.showPayState = true;
      }
      // console.log(this.payNo);
      if (this.payNo == "") {
        return;
      }
      var params = {
        payNo: this.payNo,
      };

      payApi.serachPayState(params).then((res) => {
        // console.log(res, "zhifu");
        if (res.code != 200) {
          return;
        }
        this.payState = res.data.state;

        if (this.payState == 1) {
          setInterval(this.timer);
          this.payTipContent = "支付成功";
          sessionStorage.removeItem("payNo");
          this.payMsg = "";
        } else if (res.code == 401) {
          setTimeout(() => {
            this.doSearchPayState();
          }, 1000);
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.white {
  background: #eeeff4;
  color: #333;

  .main-block {
    background: #eeeff4;
  }

  .bg12161F {
    background: #fff;
  }

  .pay-title {
    padding: 10px;
    min-height: 1.1rem;
    position: relative;
    border-bottom: 8px solid #eeeff4;
    background-color: white;
  }

  .pricelist .active {
    border-color: #f44336;
    background: rgba(244, 67, 54, 0.05);
  }

  .pricelist {
    background: #fff;
  }

  .title {
    height: 44px;
    line-height: 44px;
    padding-left: 14px;
    border-bottom: 1px solid #eeeff4;
    background: #fff;
    font-weight: 500;
  }

  .pay {
    background: #fff;
  }

  .tishi {
    background: #fff;
  }

  .pay-state-dialog {
    background: #fff;
  }

  .recommend {
    min-width: 30px;
    padding: 0 6px;
    height: 20px;
    font-size: 12px;
    text-align: center;

    background: linear-gradient(270deg, #ff7121 0%, #ff4042 100%);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
  }

  .Points-pay {
    width: 7.5rem;
    height: 44px;
    background: #fff9ed;
    border-radius: 4px;
    font-size: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff9500;
  }

  .fxts {
    color: #333;
  }

  .remark {
    color: #999999;
  }

  .pay-boot {
    background-color: white;
  }

  .tip-content {
    color: rgba(51, 51, 51, 1);
  }

  .pay-msg {
    color: rgba(102, 102, 102, 1);
  }

  .pay-btn-cancel {
    color: rgba(153, 153, 153, 1);
  }
}

.black {
  color: #f0f1f4;
  background: #000;
  height: 100vh;
  overflow: hidden;

  .main-block {
    background: #000;
  }

  .bg12161F {
    background: #12161f;
  }

  /deep/.van-cell {
    background: #12161f;
    color: #fff;
  }

  /deep/.van-cell__right-icon {
    color: #a9aeb3;
  }

  .pay-title {
    padding: 10px;
    min-height: 1.1rem;
    position: relative;
    border-bottom: 8px solid #000;
    background-color: #12161f;
  }

  .pricelist .active {
    background: linear-gradient(180deg, #12161f 0%, #352a1c 100%);
    border-radius: 2px;
    border: 1px solid #f44336;
  }

  .pricelist,
  .pay {
    background: #12161f;
  }

  .title {
    height: 44px;
    line-height: 44px;
    padding-left: 14px;
    background: #12161f;
    font-weight: 500;
  }

  .tishi {
    background: #12161f;
  }

  .pay-state-dialog {
    background: #171c27;
  }

  .recommend {
    // background: #ef4034;
  }

  .Points-pay {
    width: 7.5rem;
    height: 44px;
    background: #3a2a15;
    border-radius: 4px;
    font-size: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff9500;
  }

  .fxts {
    color: #f9f9f9;
  }

  .remark {
    color: #a7b0c4;
  }

  .pay-boot {
    background-color: #171c27;
  }

  .tip-content {
    color: #f0f1f4;
  }

  .pay-msg {
    color: #676d78;
  }

  .pay-btn-cancel {
    color: #a7b0c4;
  }

  .pay-title .pro-summary {
    color: #a7b0c4;
  }
}

.bdeeeff4 {
  border-bottom: 8px solid #eeeff4;
}

.bd000 {
  border-bottom: 8px solid #000;
}

.main-block {
  overflow-y: scroll;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 164px;
  background-color: rgba(0, 0, 0, 0);
}

.block-title {
  margin: 0;
  /* padding: 10px; */
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

.pay-title {
  padding: 10px;
  position: relative;
  // border-bottom: 8px solid #eeeff4;
  // background-color: white;
}

.pay-title .title-left {
  position: absolute;
  left: 10px;
  top: 10px;
}

.pay-title .title-right {
  display: inline-block;
  margin-left: 108px;
}

.pay-title .pro-name {
  display: block;
  margin-bottom: 10px;
  font-size: 17px;
  font-weight: bold;
}

.pay-title .pro-summary {
  display: block;
  color: #999999;
  font-size: 12px;
  height: 12px;
  line-height: 12px;
}

.pricelist {
  overflow-y: hidden;
  overflow-x: scroll;
  padding: 10px;
  height: 150px;
  white-space: nowrap;
}

.pricelist .priceitem {
  display: inline-block;
  position: relative;
  vertical-align: top;
  min-width: 90px;
  padding: 0 5px;
  height: 130px;
  margin-right: 10px;
  text-align: center;
  border: 1px solid rgba(244, 67, 54, 0.2);
  border-radius: 3px;
}

.pricelist .active {
  border-color: #f44336;
  background: rgba(244, 67, 54, 0.05);
}

.pricelist .priceitem .price-name {
  display: block;
  font-size: 14px;
  margin-top: 34px;
  font-weight: 500;
  height: 14px;
  line-height: 14px;
}

.pricelist .priceitem .price-discount {
  display: block;
  color: #f44336;
  font-size: 20px;
  font-weight: 400;
  height: 22px;
  line-height: 22px;
  margin-top: 16px;
}

.pricelist .priceitem .price-normal {
  display: block;
  color: #999999;
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  font-weight: 400;
  text-decoration: line-through;
  margin-top: 8px;
}

.pricelist .priceitem .recommend {
  min-width: 30px;
  padding: 0 6px;
  height: 20px;
  font-size: 12px;
  text-align: center;

  background: linear-gradient(270deg, #ff7121 0%, #ff4042 100%);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
}

.pay {
  position: relative;
  text-align: center;
}

.pay .pay-item {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 50%;
  text-align: center;
  font-size: 10px;
  color: #999999;
  padding: 0 0 15px 0;
}

.pay .wechatpay {
  position: relative;
  width: 90%;
  height: 80px;
  border-radius: 3px;
  padding-top: 15px;
  margin-left: 5%;
  border: 1px solid #ccc;

  position: relative;
}

.pay .alipay {
  position: relative;
  width: 90%;
  height: 80px;
  border-radius: 3px;
  padding-top: 15px;
  margin-left: 5%;
  border: 1px solid #ccc;
  /* background: #ccc; */
  position: relative;
}

.pay .pay-item .remark {
  position: absolute;
  bottom: 10px;
  /* padding: 0 10px; */
  width: 100%;
  text-align: center;
}

.pay .pay-item .icon {
  width: 80%;
  padding-left: 10%;
  height: auto;
}

.pay .pay-item .icon1 {
  width: 80%;
  padding-left: 10%;
  height: auto;
}

.pay .pay-item .wechatactive {
  background: rgba(65, 176, 53, 0.05);
  border-color: rgba(65, 176, 53, 1) !important;
}

.pay .pay-item .alipayactive {
  background: rgba(80, 135, 255, 0.05);
  border-color: rgba(80, 135, 255, 1) !important;
}

.pay-boot {
  // padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.pay-dialog {
  background: transparent;
  width: 260px;
  border-radius: 0;
}

.pay-state-dialog {
  width: 260px;
  height: 298px;
  // background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  text-align: center;
}

.pay-state-dialog .tip-content {
  height: 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;

  line-height: 16px;
  margin-top: 22px;
}

.pay-state-dialog .pay-msg {
  height: 15px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 15px;
  margin-top: 26px;
}

.pay-state-dialog .pay-btn-complate,
.pay-state-dialog .pay-btn-success,
.pay-state-dialog .pay-btn-fail {
  width: 170px;
  height: 40px;
  background: rgba(244, 67, 54, 1);
  border-radius: 2px;
  margin-top: 24px;
  margin-left: 45px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pay-state-dialog .pay-btn-cancel {
  width: 60px;
  height: 15px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 15px;
  margin-top: 16px;
  margin-left: 100px;
}

/* .thshi {
  height: 100px;
  background: #fff;
} */
.fxts {
  width: 6.33rem;
  height: 0.8rem;
  margin-top: 0.24rem;
  display: flex;
  font-size: 0.28rem;
  // color: #333;
}

.valueClass {
  font-size: 19px;
  font-weight: 500;
  color: #fa3b32;
}

.valueClass1 {
  font-size: 15px;
  font-weight: 500;
  color: #fa3b32;
}

.black {
  .pay .wechatpay {
    border: 1px solid rgba(65, 176, 53, 0.2);
  }

  .pay .alipay {
    border: 1px solid rgba(80, 135, 255, 0.2);
  }

  .pay1 {
    background: #12161f;

    .pay1_item {
      border-bottom: 1px solid #262e41;
    }

    div:last-child {
      border-bottom: 0;
      // border: 12161F !important;
    }
  }
}

.pay1 {
  background: #fff;
  padding: 0 0.32rem;
}

.pay1_item {
  height: 1.2rem;
  padding: 0 0.21rem 0 0.44rem;
  display: flex;
  align-items: center;

  border-bottom: 1px solid #eeeeee;

  p {
    width: 4.76rem;
  }
}

.pay1 div:last-child {
  border-bottom: 0 // border: 12161F !important;
}

.loading {
  display: inline-block;
  height: 1em;
  line-height: 1;
  text-align: left;
  vertical-align: -.25em;
  overflow: hidden;
}

.loading::before {
  display: block;
  content: '...\A..\A.';
  white-space: pre-wrap;
  animation: loading 2s infinite step-start both;
}

@keyframes loading {
  33.3% {
    transform: translateY(-2em);
  }

  66.6% {
    transform: translateY(-1em);
  }
}
</style>